import type { Ref } from 'vue'
import { useUserLocalStorage } from '../user/users'

const STORAGE_KEY_DRAFT = 'draft'

// Define interfaces first
export interface MArticleDraft {
  id: string
  title: string
  content: string
  baseInfo: string
}

export interface ArticleDraft {
  id: string
  content: string
}

// Define DraftStore class before using it
class DraftStore {
  maDraft: Record<string, MArticleDraft>
  articleDraft: Record<string, ArticleDraft>

  constructor() {
    this.maDraft = {}
    this.articleDraft = {}
  }

  saveMArticle(serviceId: string, artcile: MArticleDraft) {
    this.maDraft[serviceId] = artcile
  }

  getMArticle(serviceId: string): MArticleDraft | undefined {
    return this.maDraft[serviceId]
  }

  deleteMArticle(serviceId: string) {
    delete this.maDraft[serviceId]
  }

  saveArticle(serviceId: string, articleId: string | null, content: ArticleDraft) {
    const key = serviceId + '_' + (articleId ? articleId : '')
    this.articleDraft[key] = content
  }

  getArticle(serviceId: string, articleId: string | null): ArticleDraft | undefined {
    const key = serviceId + '_' + (articleId ? articleId : '')
    return this.articleDraft[key]
  }

  deleteArticle(serviceId: string, articleId: string | null) {
    const key = serviceId + '_' + (articleId ? articleId : '')
    delete this.articleDraft[key]
  }
}

// Define helper function after the class
function getDefaultDraft(): DraftStore {
  return new DraftStore()
}

// Now we can safely use DraftStore and getDefaultDraft
export const draftStore: Ref<DraftStore> = useUserLocalStorage<DraftStore>(STORAGE_KEY_DRAFT, getDefaultDraft)
